import React from 'react';
import { motion } from 'framer-motion';
export function CosmicBackground() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-117">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-hubble-card/40 via-hubble-bg to-hubble-bg" data-id="element-118"></div>

      {/* Star dots pattern */}
      <div className="absolute inset-0 opacity-[0.1]" style={{
      backgroundImage: `radial-gradient(circle at center, #3DB89E 1px, transparent 1px)`,
      backgroundSize: '48px 48px'
    }} data-id="element-119"></div>

      {/* Large orbital rings */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-[1200px] h-[800px] opacity-30" data-id="element-120">
        <motion.div animate={{
        rotate: 360
      }} transition={{
        duration: 150,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute top-[-20%] left-1/2 -translate-x-1/2 w-[1200px] h-[1200px] border border-hubble-border rounded-full" data-id="element-121" />
        <motion.div animate={{
        rotate: -360
      }} transition={{
        duration: 200,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute top-[-10%] left-1/2 -translate-x-1/2 w-[900px] h-[900px] border border-hubble-muted/30 rounded-full" data-id="element-122" />
        <motion.div animate={{
        rotate: 360
      }} transition={{
        duration: 100,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute top-[0%] left-1/2 -translate-x-1/2 w-[600px] h-[600px] border border-hubble-accent/10 rounded-full" data-id="element-123" />
      </div>

      {/* Glow effects */}
      <div className="absolute top-[-10%] left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-hubble-primary/10 blur-[120px] rounded-full" data-id="element-124"></div>
    </div>;
}